import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import {
  ActionSheetController,
  AlertController,
  ModalController,
  NavController,
  PopoverController,
  Platform
} from '@ionic/angular';
import {
  StockOrder,
  StockOrderLineItem,
} from '../../models/product-stock-order.model';
import { Product, ProductSupplier } from '../../models';
import { ProductService } from '../../services/product.service';
import { StockOrderService } from '../../services/product-stock-order.service';
import { List } from 'immutable';
import { of, Observable } from 'rxjs';
import { Utilities } from '../../utilities/utilities';
import { Router, ActivatedRoute } from '@angular/router';

import { ProductListComponent } from '../product-list/product-list.component';
import { ProductSupplierService } from '../../services/product-supplier.service';
interface IRow {
  ID: number;
  productID: number;
  name: string;
  productSupplierID: number;
  stock: number;
  quantity: number;
  received: number;
  supplierPrice: number;
}

interface IStockOrderModalCallBackData {
  stockOrder: StockOrder;
}

@Component({
  selector: 'app-inventory-order',
  templateUrl: './inventory-order.page.html',
  styleUrls: ['./inventory-order.page.scss'],
})
export class InventoryOrderPage implements OnInit {
  public isLoading: boolean;

  public submitted: boolean;

  public stockOrderID: number;

  public products: List<Product>;

  public stockOrder: StockOrder;

  public stockOrderLineItems: List<StockOrderLineItem>;

  public stats: Array<IRow>;

  public errorOccurredWhileLoadingStockOrderInfo: boolean;

  public orderItemID: number;

  public orderItemForm: UntypedFormGroup;

  public orderItemName: UntypedFormControl;
  public notes: UntypedFormControl;
  public supplierName: string;
  public supplierID: number;
  public supplier: ProductSupplier;
  public supplierInvoiceNumber: UntypedFormControl;
  public orderStatusID: UntypedFormControl;
  public orderStatus: string;
  public expectedDelivery: UntypedFormControl;
  public productSupplier: ProductSupplier;
  public productSuppliers;
  public isIOS: boolean;
  public title: string;
  constructor(
    private productService: ProductService,
    private stockOrderService: StockOrderService,
    private alertCtrl: AlertController,
    private formBuilder: UntypedFormBuilder,
    private modalController: ModalController,
    private router: Router,
    private route: ActivatedRoute,
    private productSupplierService: ProductSupplierService,
    private platform: Platform
  ) {
    // this.orderItemID = this.navParams.get('ID');
    // this.stockOrderID = this.navParams.get('stockOrderID');
    this.route.queryParams.subscribe((params) => {
      this.stockOrderID = params['id'];

    });
    // this.stockOrder = new StockOrder({
    //     ID: null,
    //     supplierID: null,
    //     supplierName: '',
    //     supplierInvoiceNumber: '',
    //     returnDate: '',
    //     lineItems: null,
    //     notes: ''
    // });
    this.submitted = false;
    this.isLoading = true;
    this.products = List([]);
    this.stockOrderLineItems = List([]);
    this.stats = [];
    this.supplierName = '';
    this.supplierInvoiceNumber = new UntypedFormControl('');
    this.orderItemName = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(128)])
    );
    this.notes = new UntypedFormControl(
      '',
      Validators.compose([Validators.maxLength(128)])
    );
    this.expectedDelivery = new UntypedFormControl(
      '',
      Validators.compose([Validators.required])
    );
    this.orderStatusID = new UntypedFormControl(
      '',
      Validators.compose([Validators.required])
    );
    this.orderItemForm = this.formBuilder.group({
      supplierName: this.supplierName,
      supplierInvoiceNumber: this.supplierInvoiceNumber,
      orderStatusID: this.orderStatusID,
      orderStatus: this.orderStatus,
      expectedDelivery: this.expectedDelivery,
      notes: this.notes,
    });
  }

  public ngOnInit() {
    if(this.platform.is('ios')) this.isIOS = true;
    this.title = "Create Stock Order"
    this.loadStockOrder();
    this.refresh();
  }

  public mapPaginatorValue() {
    this.products.forEach((product) => {
      let ID = undefined;
      let productID = product.getID();
      let name = product.getName();
      let stock = product.getStock();
      let productSupplierID = product.getSupplierID();
      let quantity = undefined;
      let received = undefined;
      let supplierPrice = undefined;
      this.stats.push({
        ID,
        productID,
        name,
        stock,
        productSupplierID,
        quantity,
        received,
        supplierPrice,
      });
    });
  }

  public refresh() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingStockOrderInfo = false;
    this.productSupplierService.loadProductSuppliers().subscribe({
      next: (productSuppliers) => {
        this.isLoading = false;
        this.productSuppliers = productSuppliers.toArray();
      },
      error: (err) => {
        this.isLoading = false;
      },
    });
  }

  public loadStockOrder() {
    this.isLoading = true;
    if (!this.stockOrderID) {
      this.stockOrder = new StockOrder({
        ID: undefined,
        supplierID: undefined,
        supplierName: undefined,
        supplierInvoiceNumber: undefined,
        orderStatus: undefined,
        orderStatusID: undefined,
        expectedDelivery: undefined,
        notes: undefined,
        lineItems: undefined,
        createdDate: undefined,
      });
      this.orderStatusID.setValue(1);
      this.expectedDelivery.setValue(new Date());
    } else {
      this.title = "Edit Stock Order"
      this.stockOrderService
        .loadItemByID(this.stockOrderID)
        .subscribe((val) => {
          this.stockOrder = val;
          this.supplierID = val.supplierID;
          this.productSupplierService.loadProductSupplierByID(this.supplierID).subscribe(
            supplier => {this.supplier = supplier;}
          )
          this.supplierName = val.supplierName;
          this.supplierInvoiceNumber.setValue(val.supplierInvoiceNumber);
          this.orderStatus = val.orderStatus;
          this.orderStatusID.setValue(val.orderStatusID);
          this.expectedDelivery.setValue(val.expectedDelivery);
          this.notes.setValue(val.notes);
          val.lineItems.forEach((lineItem) => {
            let ID = lineItem.ID;
            let productID = lineItem.productID;
            this.productService
              .loadProductByID(productID)
              .subscribe((product) => {
                let productID = product.getID();
                let name = product.getName();
                let stock = product.getStock();
                let productSupplierID = product.getSupplierID();
                let quantity = product.quantity;
                let received = lineItem.received;
                let supplierPrice = lineItem.supplierPrice;
                this.stats.push({
                  ID,
                  productID,
                  name,
                  stock,
                  productSupplierID,
                  quantity,
                  received,
                  supplierPrice,
                });
              });
          });
        });
    }
  }

  public async showProductList() {
    if (!this.supplier) {
      alert('select supplier first');
      return;
    }
    const modal = await this.modalController.create({
      component: ProductListComponent,
      componentProps: {
        supplierID: this.supplier.id
      }
    });
    modal.present();
    modal.onDidDismiss().then((data) => {
      if (data.data) {
        data.data.selectedProducts.forEach((product) => {
          let ID = undefined;
          let productID = product.ID;
          this.productService
            .loadProductByID(productID)
            .subscribe((product) => {
              let quantity = product.reorderAmount;
              let name = product.name;
              let stock = product.getStock();
              let productSupplierID = product.supplierID;
              let received = 0;
              let supplierPrice = product.price;
              if (
                this.stats.findIndex(
                  (newItem) => newItem.productID === product.id
                ) === -1
              ) {
                this.stats.push({
                  ID,
                  productID,
                  name,
                  stock,
                  productSupplierID,
                  quantity,
                  received,
                  supplierPrice,
                });
              }
            });
        });
      }
    });
  }

  public remove(stat) {
    this.stats.splice(this.stats.indexOf(stat), 1);
  }

  public orderSave() {
    if (!this.isFormValid()) {
      return;
    }
    let stockOrder = new StockOrder({
      ID: undefined,
      supplierID: undefined,
      supplierName: undefined,
      supplierInvoiceNumber: undefined,
      orderStatusID: undefined,
      orderStatus: undefined,
      expectedDelivery: undefined,
      notes: undefined,
      lineItems: List([]),
      createdDate: undefined,
    });
    stockOrder = stockOrder.setID(this.stockOrderID);
    stockOrder = stockOrder.setSupplierID(this.supplier.id);
    stockOrder = stockOrder.setSupplierName(this.supplierName);
    stockOrder = stockOrder.setSupplierInvoiceNumber(
      this.supplierInvoiceNumber.value
    );
    stockOrder = stockOrder.setStatusID(this.orderStatusID.value);
    stockOrder = stockOrder.setExpectedDelivery(
      Utilities.formatDate(this.expectedDelivery.value)
    );
    stockOrder = stockOrder.setNotes(this.notes.value);
    let lineItems = [];
    this.stats.forEach((stat) => lineItems.push(stat));
    stockOrder = stockOrder.setLineItems(List(lineItems));

    this.stockOrderService.saveStockOrder(stockOrder).subscribe({
      next: (stockOrder) => {
        let callBackData: IStockOrderModalCallBackData = {
          stockOrder: stockOrder,
        };

        this.isLoading = false;
        this.router.navigateByUrl('/inventory');
      },
      error: async (error) => {
        this.isLoading = false;
        const alert = await this.alertCtrl.create(
          Utilities.getDefaultErrorMessageConfig()
        );
        alert.present();
      },
    });
  }

  public isFormValid(): boolean {
    if (!this.orderItemForm.valid || !this.supplier.id) {
      alert('please fill in all fields');
      return false;
    }
    return true;
  }
}
